/**
 * These values are logic keys, not display text — `mergeGeoData.js`'s legacy
 * map switches on them against `MAP_SCALES` (constants/geo.js), and
 * `SearchLocations.tsx` matches a boundary search result's own `type` field
 * against them. #4621 changed `Dma` to 'Metro' to relabel the UI and silently
 * broke that merge (MAP_SCALES.DMA stayed 'DMA', so the switch never matched
 * and the legacy DMA map rendered nothing) — live since 29 Sep, caught 6 Oct.
 * Use `GEO_TYPE_LABELS` (same file) for anything user-facing.
 */
enum GeoType {
  Dma = 'DMA',
  Zip = 'ZIP',
  State = 'State',
  County = 'County',
  CongressionalDistrict = 'Congressional Districts',
  City = 'City',
  Country = 'Country',
}

export default GeoType;

/** Display text for a GeoType, where it differs from the logic key above (#4620/#4621/#4701). */
export const GEO_TYPE_LABELS: Record<GeoType, string> = {
  [GeoType.Dma]: 'Market',
  [GeoType.Zip]: GeoType.Zip,
  [GeoType.State]: GeoType.State,
  [GeoType.County]: GeoType.County,
  [GeoType.CongressionalDistrict]: GeoType.CongressionalDistrict,
  [GeoType.City]: GeoType.City,
  [GeoType.Country]: GeoType.Country,
};

/**
 * Display text for a geo scale value from `GeoType`, `MapScale` or `MAP_SCALES`
 * (they share these strings). Any other value, e.g. a non-geo report view, is
 * returned unchanged.
 */
export const geoTypeLabel = (value: string): string => GEO_TYPE_LABELS[value as GeoType] ?? value;
